import { forEach, pick, result } from 'lodash';

export type Place = {
  address: string | undefined,
  country: string,
  formatted_phone_number: string | undefined,
  international_phone_number: string | undefined,
  latitude: number,
  locality: string,
  longitude: number,
  name: string | undefined,
  place_id: string | undefined,
  place_type: string,
  postal_code: string,
  region: string,
  street_name: string,
  street_number: string,
  sub_locality: string,
  website: string | undefined,
};

export const flattenAddressComponents = (data: google.maps.places.PlaceResult) => {
  const result: { [key: string]: any } = {};
  forEach(data.address_components, ({ types, ...rest }) => {
    forEach(types, type => {
      result[type] = pick(rest, ['long_name', 'short_name']);
    });
  });
  return result;
};

export const convertToPlace = (data: google.maps.places.PlaceResult): Place => {
  const components = flattenAddressComponents(data);
  return {
    name: data.name,
    address: data.formatted_address,
    street_number: result(components.street_number, 'short_name'),
    street_name: result(components.route, 'short_name'),
    locality: result(components.postal_town, 'long_name') ||
      result(components.locality, 'long_name'),
    sub_locality: result(components.sublocality, 'short_name'),
    region: result(components.administrative_area_level_1, 'short_name'),
    postal_code: result(components.postal_code, 'long_name'),
    country: result(components.country, 'short_name'),
    latitude: result(data.geometry, 'location.lat'),
    longitude: result(data.geometry, 'location.lng'),
    place_type: (data.types || []).join(','),
    place_id: data.place_id,
    formatted_phone_number: data.formatted_phone_number,
    international_phone_number: data.international_phone_number,
    website: data.website,
  };
};
